module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=MX - Mexico.1c80bb46.svg";